var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgModels = function SvgModels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 220 204",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.85 41.66a22.995 22.995 0 1 1 .001 45.992 22.995 22.995 0 0 1 0-45.991Zm0 74.321a22.999 22.999 0 0 1 16.26 39.256 22.994 22.994 0 0 1-39.256-16.26 22.997 22.997 0 0 1 22.997-22.996Z",
    fill: "currentColor",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M112.039 155.097a22.99 22.99 0 0 1 21.246 14.196 22.992 22.992 0 0 1-4.985 25.06 22.996 22.996 0 1 1-16.261-39.256Zm0-76.454a22.993 22.993 0 0 1 22.554 27.482 22.991 22.991 0 0 1-18.067 18.068 22.996 22.996 0 1 1-4.487-45.55Zm0-76.098a22.993 22.993 0 0 1 21.246 14.195 22.994 22.994 0 0 1-4.985 25.061 22.999 22.999 0 0 1-25.061 4.985 22.997 22.997 0 0 1 8.8-44.241ZM44.551 55.216l-.15-.322 46.227-21.691.15.322-46.227 21.691Zm51.7-10.58.284.216-58.318 76.454-.285-.216 58.319-76.454ZM38.288 82.543l.282-.216 58.319 76.098-.283.216-58.318-76.098Zm5.903 46.994-.142-.326 44.45-19.202.142.326-44.45 19.202Zm45.161-36.95-.145.324-44.45-19.914.145-.324 44.45 19.914Zm.711 74.676-.142.325-45.161-19.914.142-.325 45.161 19.914Zm84.083-49.038.246.257-44.45 42.672-.246-.257 44.45-42.672Zm-6.277-17.297v.355h-31.293v-.355h31.293Zm7.234-15.775-.245.257-44.806-42.672.246-.257 44.805 42.672Z",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.405 124.63c12.698 0 22.991-10.293 22.991-22.991s-10.293-22.992-22.991-22.992-22.992 10.294-22.992 22.992 10.294 22.991 22.992 22.991Z",
    strokeWidth: 3
  })));
};
var Memo = /*#__PURE__*/memo(SvgModels);
export default Memo;